import QuoteSearch from './components/QuoteSearch.vue'
import QuoteForm from './components/QuoteForm.vue'
import QuoteRates from './components/QuoteRates.vue'
import QuoteUploads from './components/QuoteUploads.vue'
import store from '../../store'
import event from '../../event'

export default [
  {
    path: 'quote',
    alias: '',
    component: QuoteSearch,
    name: 'Quotes - Search',
    meta: {description: 'View and Search for prior Quotes'},
    beforeEnter: (to, from, next) => {
      event.$emit('loading-on', {})
      store.dispatch('stats/getRecentEntities', 'job').then(next)
      .catch(err => {
        console.log(err)
        event.$emit('toast', { type: 'error', message: 'Unable to load resources' })
        next(false)
      }).then(() => event.$emit('loading-off', {}))
    }
  },
  {
    path: 'quote/new',
    alias: '',
    component: QuoteForm,
    name: 'Add a new Quote',
    meta: {
      hide: true
    },
    beforeEnter: (to, from, next) => {
      event.$emit('loading-on', {})
      store.dispatch('systemOption/initialise').then(() => {
        event.$emit('loading-off', {})
        next()
      }).catch(err => {
        event.$emit('loading-off', {})
        event.$emit('toast', { message: err, type: 'warning' })
        next(false)
      })
    }
  },
  {
    path: 'quote/:id/edit',
    alias: '',
    component: QuoteForm,
    name: 'Quote Form - edit',
    meta: {description: 'Edit a quote'},
    beforeEnter: (to, from, next) => {
      event.$emit('loading-on', {})
      store.dispatch('systemOption/initialise').then(() => {
        event.$emit('loading-off', {})
        next()
      }).catch(err => {
        event.$emit('loading-off', {})
        event.$emit('toast', { message: err, type: 'warning' })
        next(false)
      })
    }
  },
  {
    path: 'quote/batch-upload',
    alias: '',
    component: QuoteUploads,
    name: 'Quote Batch Upload',
    meta: {description: 'Upload quotes'},
    beforeEnter: (to, from, next) => {
      next()
    }
  },
  {
    path: 'quote/results',
    alias: '',
    component: QuoteRates,
    name: 'Quote Responses',
    meta: {description: 'View rates'}
  }

]



// WEBPACK FOOTER //
// ./src/modules/quote/routes.js